let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aO2Db")).then(() => parcelRequire('96Dop'));